import { Card, CardBody } from '@heroui/react';
import React from 'react';
import { FiChevronRight, FiUploadCloud } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

import { PageHeader } from '../../components/PageHeader';

interface WorkflowEntry {
  path: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

const WORKFLOWS: WorkflowEntry[] = [
  {
    path: '/workflows/order-guide-upload',
    title: 'Order Guide Bulk Upload',
    description:
      'Upload a CSV to add or update products across many order guides at once. Supports chats with multiple order guides.',
    icon: <FiUploadCloud className="w-6 h-6" />,
  },
];

export const WorkflowsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-6">
      <PageHeader
        title="Workflows"
        description="Bulk operations and multi-step tools for customer success and ops."
      />

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {WORKFLOWS.map((workflow) => (
          <Card
            key={workflow.path}
            isPressable
            onPress={() => navigate(workflow.path)}
            // !rounded-lg: the global button pill-radius rule in styles/index.css
            // also hits pressable cards (they render as react-aria buttons)
            className="!rounded-lg hover:border-primary border border-default-200"
          >
            <CardBody className="flex flex-row items-start gap-4 p-5">
              <div className="text-primary mt-0.5">{workflow.icon}</div>
              <div className="flex-1 space-y-1">
                <h2 className="text-base font-semibold text-foreground">
                  {workflow.title}
                </h2>
                <p className="text-sm text-default-500">
                  {workflow.description}
                </p>
              </div>
              <FiChevronRight className="w-5 h-5 text-default-400 self-center" />
            </CardBody>
          </Card>
        ))}
      </div>
    </div>
  );
};
